import moment from 'moment'

export const normalizeDate = (date: string, locale?: boolean) => {
  const ISOdate = moment(date).toISOString()
  const momentISOObject = moment(ISOdate)

  return moment(moment(momentISOObject).toISOString()).format(locale ? 'DD.MM.YYYY.' : 'YYYY-MM-DD')
}
